/**
 * A server's picture (Console v2 §3.1): its icon once it has one; the
 * official server's mark; else Discord's acronym of its name on a glass
 * tile ("Ali's server" reads "As").
 */
import type { Snowflake } from '@neosocial/protocol';
import { assetUrl } from '../lib/config';
import { useData } from '../store/data';
import { officialGuildId } from '../store/selectors';
import markUrl from '../assets/mark.svg';

/** Discord's acronym: the first letter of each word, "'s" left out, at most 4. */
export function guildAcronym(name: string): string {
  const words = name
    .replace(/['’]s\b/gi, '')
    .split(/\s+/)
    .filter(Boolean);
  return words
    .map((w) => [...w][0] ?? '')
    .join('')
    .slice(0, 4);
}

export function GuildIcon({ guildId, cls }: { guildId: Snowflake; cls?: string }) {
  const icon = useData((d) => d.guilds[guildId]?.icon ?? null);
  const name = useData((d) => d.guilds[guildId]?.name ?? '');
  const official = useData((d) => officialGuildId(d) === guildId);
  const url = icon ? assetUrl(icon) : null;
  if (url)
    return <img className={['rail-srv-icon', cls].filter(Boolean).join(' ')} src={url} alt="" />;
  if (official) return <img className={cls} src={markUrl} alt="" width={28} height={28} />;
  const short = guildAcronym(name);
  return (
    <span
      className={['sv-acronym', cls].filter(Boolean).join(' ')}
      data-len={Math.min(short.length, 4)}
      dir="auto"
      aria-hidden="true"
    >
      {short}
    </span>
  );
}
